require("core-js/features/array/find");

import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue";
import ValidationMessage from "../../Default/common/validation-message.vue";
import FormGroupStatic from "../phases/form-group-static.vue";
import Authentication from "./authentication.vue";
import ContractPartnerCard from "./components/contract-partner-card.vue";
import ContractPartnerModal from "./components/contract-partner-modal.vue";
import { mapState } from "vuex";
import { IContractSettings } from "../../new-contract-vuex-store";
import { ContactPersonViewModel, IContactPersonViewModel, AddressViewModel, ICustomerViewModel, ICompanyViewModel, IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { ArrayUtils } from "@/Scripts/inpulse/Common-utils";
import { ContactPersonUtils } from "@/Scripts/inpulse/ContactPersonUtils";
import { SectionChecker } from "../../Default/common/section";
import LoadingComponent from "@/Scripts/vue-components/common/loading.vue";

class Checker extends SectionChecker {
    constructor() {
        super();
        this.properties = [
            (contract: IContractViewModel) => contract.Customer.Pin,
            (contract: IContractViewModel) => contract.Customer.FirstName,
            (contract: IContractViewModel) => contract.Customer.LastName,
            (contract: IContractViewModel) => contract.Customer.Phone,
             (contract: IContractViewModel) => contract.Customer.Email
        ];
        this.validationIds = ["Phone", "Email"];
    }
}

export let CustomerInformationChecker = new Checker();

declare var currentLocale: string;
@Component({
    components: {
        ValidatedFormGroup,
        ValidationMessage,
        FormGroupStatic,
        Authentication,
        ContractPartnerCard,
        ContractPartnerModal,
        LoadingIndicator: LoadingComponent
    },computed: mapState({        
        customerCulture(): string {
            let custCult = this.customer.CultureCode;
            if (custCult === null || custCult === '') {
                custCult = currentLocale;
            }
            if (custCult !== null) {
                if (custCult.startsWith('fi')) {
                    custCult = 'suomi'
                }
                else {
                    custCult = 'ruotsi'
                }
                return custCult;
            }
        }
    }),
})

export default class CustomerInformation extends Vue {
    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get customer(): ICustomerViewModel { return this.contract.Customer; }
    get company(): ICompanyViewModel { return this.contract.Company; }
    get strongContractAuthentication(): boolean { return this.contract.StrongContractAuthentication }
    get contractToNewAddressSelection(): number { return this.contract.ContractToNewAddressSelection }
    get contractPartners(): IContactPersonViewModel[] {
        let res = [];
        this.customer.ContractPartners.forEach(x => {
            if (!ContactPersonUtils.isEmpty(x))
                res.push(x);
        });
        return res;
    }
    get offerRequest(): boolean { return this.$store.state.offerRequest; }

    streetModel: string = "";
    zipModel: string = "";

    contractPartnerModalShow: boolean = false;
    contractPartner: IContactPersonViewModel = null;
    cachedContractPartners: IContactPersonViewModel[] = null;
    loadingPartners = false;

    @Prop()
    public validationErrors: any;

    @Prop()
    public showAuthentication: boolean;

    @Prop()
    public hideAuthenticationForcedText: boolean;

    @Emit()
    customerValueUpdated(allSet: boolean) {}
  
    @Emit()
    authenticate() { }
    
    constructor() {
        super();
    }

    addContractPartners() {
        //if (this.contractPartners != null && this.contractPartners.length >= 2) {
        //    console.error("Only 2 contract partners can be added!");
        //    return;
        //}
        debugger;
        this.cachedContractPartners = this.contractPartners != null
            ? JSON.parse(JSON.stringify(this.contractPartners))
            : [];

        this.contractPartner = new ContactPersonViewModel();
        this.cachedContractPartners.push(this.contractPartner);
        this.contractPartnerModalShow = true;
    }

    modifyContractPartner(contractPartner: IContactPersonViewModel) {
        // When modify is called, there MUST be contract partners. It's a bug if none is found.
        let ndx = this.customer.ContractPartners.indexOf(contractPartner);
        this.cachedContractPartners = JSON.parse(JSON.stringify(this.contractPartners));
        this.contractPartner = this.cachedContractPartners[ndx];
        this.contractPartnerModalShow = true;
    }

    removeContractPartner(contractPartner: IContactPersonViewModel) {
        console.log("Remove contract partner!");
        let ndx = this.cachedContractPartners.indexOf(contractPartner)
        this.cachedContractPartners.splice(ndx, 1);
        this.$store.dispatch("setContractPartners", this.cachedContractPartners);
    }

    strip(ctor: any, obj: object) {
        let keys = Object.keys(new ctor());
        let keyMap = {};
        keys.forEach((key) => {
            keyMap[key] = true;
        });
        for (let p in obj) {
            if (obj.hasOwnProperty(p)) {
                if (keyMap[p] === undefined) {
                    obj[p] = undefined;
                }
            }
        }
    }

    contractPartnerOk(contractPartner: IContactPersonViewModel) {
        // We are handling an object we got from the server. Its Address contains all the properties declared in the server side (C#) view model.
        // We must get rid of those properties that do not exist in the client side view model. Without doing so, the address parsing scheme
        // would not work, since SignalR creates the AddressViewModel object and sets all of its properties, and that would mess up the result.
        this.cachedContractPartners.forEach(x => this.strip(AddressViewModel, x.Address));
        let nonEmpty: IContactPersonViewModel[] = ArrayUtils.findAll(this.cachedContractPartners, (cp) => !ContactPersonUtils.isEmpty(cp));
        // Saving the entire model is problematic, as the addressviewmodel will launch every address component setter. 
        // As the model only has StreetName set, the model will en up having entire street address on StreetName fields, wheares the rest (e.g HouseNumber, Apartment, etc) would end up empty.
        //this.$store.dispatch("setContractPartners", nonEmpty);
        this.setContractPartners(nonEmpty);
    }

    setContractPartner(partner: IContactPersonViewModel, idx: number): Promise<any> {
        let payloads = [
            { key: "FirstName__contractpartner-" + idx, value: partner.FirstName },
            { key: "LastName__contractpartner-" + idx, value: partner.LastName },
            { key: "Pin__contractpartner-" + idx, value: partner.Pin },
            { key: "Phone__contractpartner-" + idx, value: partner.Phone },
            { key: "Email__contractpartner-" + idx, value: partner.Email },
            { key: "Street__contractpartner-" + idx, value: partner.Address.Street, locale: partner.Address.Locale },
            { key: "Zip__contractpartner-" + idx, value: partner.Address.Zip, locale: partner.Address.Locale }
        ];
        return this.$store.dispatch("changeValues", payloads);
    }

    setContractPartners(partners: IContactPersonViewModel[]) {
        let idx = 1;
        let promises = [];
        partners.forEach((x: IContactPersonViewModel) => {
            promises.push(this.setContractPartner(x, idx));
            idx++;
        });
        this.loadingPartners = true;
        Promise.all(promises).then(() => {
            console.log("ContractPartners saved to hub.");
        }).catch(e => {
            console.error("Saving contractPartners failed.");
            console.log(e);
        }).finally(() => {
            this.loadingPartners = false;
        });
    };

    valueUpdated() {
        let allSet = CustomerInformationChecker.isAllSet(this.contract);
        this.customerValueUpdated(allSet);
    }

    //data() {
    //    return {
    //        selected: null,
    //        options: [
    //            { value: 'null', text: this.$t('Valitse asiointikieli'), disabled: true },
    //            { value: 'fi-FI', text: this.$t('suomi') },
    //            { value: 'se-SV', text: this.$t('ruotsi') },

    //        ]
    //    }
    //}
}